import React, { useMemo } from "react";

import { Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import formatCountdown from "@/pages/UpdateEmail/utils/formatCountdown";

type ConfirmEmailChangeActionsProps = {
  secondsUntilResend: number;
  isResending: boolean;
  isSubmitting: boolean;
  onResend: () => void;
  onEditEmail: () => void;
  "data-testid"?: string;
};

const TEXT_LINK_CLASS_NAME =
  "cursor-pointer bg-transparent p-0 text-[14px] font-medium text-foreground underline underline-offset-2 disabled:cursor-not-allowed disabled:no-underline";

/** The two ways out of the code step: get another code, or go back and fix the address. */
const ConfirmEmailChangeActions = ({
  secondsUntilResend,
  isResending,
  isSubmitting,
  onResend,
  onEditEmail,
  "data-testid": testId = "ConfirmEmailChangeActions",
}: ConfirmEmailChangeActionsProps) => {
  const resendValues = useMemo(() => ({ time: formatCountdown(secondsUntilResend) }), [secondsUntilResend]);
  const isOnCooldown = secondsUntilResend > 0;
  const isBusy = isResending || isSubmitting;

  return (
    <div className="mt-8 flex flex-col items-start gap-4" data-testid={testId}>
      {isOnCooldown ? (
        <Text variant="sm" type="opacity-60" className="block">
          <span data-testid={`${testId}-ResendCooldown`}>
            <Trans i18nKey="user:updateEmail.verify.resendCooldown" values={resendValues} />
          </span>
        </Text>
      ) : (
        <button type="button" className={TEXT_LINK_CLASS_NAME} data-testid={`${testId}-ResendButton`} disabled={isBusy} onClick={onResend}>
          <Trans i18nKey="user:updateEmail.verify.resend" />
        </button>
      )}
      <button type="button" className={TEXT_LINK_CLASS_NAME} data-testid={`${testId}-EditEmailButton`} disabled={isBusy} onClick={onEditEmail}>
        <Trans i18nKey="user:updateEmail.verify.changeEmail" />
      </button>
    </div>
  );
};

export default React.memo(ConfirmEmailChangeActions);
